module.exports = __webpack_public_path__ + "static/media/link_add_orange.0e0d0c19.svg";